import { setupApp } from '@/common/setup-app/setup-app.js'

import '../configuration/affiliate'
import '../configuration/bus'
import '../configuration/spark'
import '../configuration/axios'
import '../configuration/store'
import '../configuration/luxon'
import '../configuration/sweetalert'
import '../configuration/form'
import '../configuration/pusher'
import '../configuration/utm-data'

import '../../css/auth.css'

setupApp()
